import { ResolvedRoutesConfig } from "single-spa-layout/dist/types/isomorphic/constructRoutes";
import { MFEConfigs } from "../models/Models";
const _ = require("lodash");

export function replacePlaceholdersWithErrorAndLoadingUIParcels(
  mfeConfigs: MFEConfigs
): ResolvedRoutesConfig {
  const baseConfig = mfeConfigs.baseconfig;
  const sharedStructures = baseConfig?.shared_structures;
  if (
    !baseConfig ||
    !sharedStructures ||
    !baseConfig?.global_configuration?.routerLayout
  ) {
    throw new Error(
      `Error, something is not set, baseConfig: ${baseConfig} \n sharedStructures: ${sharedStructures}  \n baseConfig.global_configuration.routerLayout: ${baseConfig?.global_configuration?.routerLayout}`
    );
  }
  return _.cloneDeepWith(
    baseConfig.global_configuration.routerLayout,
    (value) => {
      if (value === "${error}")
        return fetchParcelFn(
          sharedStructures["mf-parcel-custom-error-view-structure"],
          "@cheshire-datasystems/mf-parcel-custom-error-view"
        );
      if (value === "${loader}")
        return fetchParcelFn(
          sharedStructures["mf-parcel-loading-view"],
          "@cheshire-datasystems/mf-parcel-loading-view"
        );
      return;
    }
  );
}

export function fetchParcelFn(structure: unknown, parcelName: string) {
  return async () => {
    const parcel = await System.import(parcelName);
    if (!parcel) {
      throw new Error(
        `Error, parcelName:${parcelName}, could not be imported `
      );
    }
    return {
      bootstrap: async (originalProps: any) => {
        return parcel.bootstrap({
          ...originalProps,
          ...{ structure },
        });
      },
      mount: async (originalProps: any) => {
        return parcel.mount({ ...originalProps, ...{ structure } });
      },
      unmount: async (originalProps: any) => {
        return parcel.unmount({ ...originalProps, ...{ structure } });
      },
      update: async (originalProps: any) => {
        return parcel.update({ ...originalProps, ...{ structure } });
      },
    };
  };
}
